/* NINEPADEL search results: result-type tabs, filter dropdowns (details), auto-submit on change. */
(function(){
  /* tabs */
  var tabs = [].slice.call(document.querySelectorAll('[data-np-rt]'));
  tabs.forEach(function(b){
    b.addEventListener('click', function(){
      tabs.forEach(function(x){ x.setAttribute('aria-pressed', x === b ? 'true' : 'false'); });
      document.querySelectorAll('[data-np-tab]').forEach(function(p){ p.hidden = p.dataset.npTab !== b.dataset.npRt; });
    });
  });

  var form = document.querySelector('[data-np-filters]');
  if(!form) return;
  var dds = [].slice.call(form.querySelectorAll('details.fdd'));

  /* one dropdown open at a time, keep it on screen */
  dds.forEach(function(d){
    d.addEventListener('toggle', function(){
      if(!d.open) return;
      dds.forEach(function(o){ if(o !== d) o.open = false; });
      var pop = d.querySelector('.pop'); if(!pop) return;
      pop.classList.remove('flip');
      var r = pop.getBoundingClientRect();
      if(r.right > window.innerWidth - 12) pop.classList.add('flip');
    });
  });
  document.addEventListener('click', function(e){ dds.forEach(function(d){ if(d.open && !d.contains(e.target)) d.open = false; }); });
  document.addEventListener('keydown', function(e){
    if(e.key !== 'Escape') return;
    dds.forEach(function(d){ if(d.open){ d.open = false; d.querySelector('summary').focus(); } });
  });

  /* drop empty price inputs so they don't end up in the URL */
  form.addEventListener('submit', function(){
    form.querySelectorAll('input[type=number]').forEach(function(i){ if(i.value === '') i.disabled = true; });
  });
  function go(){ if(form.requestSubmit) form.requestSubmit(); else { form.dispatchEvent(new Event('submit')); form.submit(); } }
  form.addEventListener('change', function(e){
    var t = e.target;
    if(t.matches('input[type=checkbox]') || t.matches('[data-np-autosubmit]')) go();
  });
})();
